// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import { css } from 'styled-components';
import { token } from '@atlaskit/tokens';
import * as zIndex from './z-index';

/**
 * Cards
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const e100 = css`
	/* stylelint-disable scale-unlimited/declaration-strict-value */
	box-shadow: ${token(
		'elevation.shadow.raised',
		`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`,
	)};
	z-index: ${zIndex.card};
`;

/**
 * Inline dialogs
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const e200 = css`
	box-shadow: ${token(
		'elevation.shadow.overlay',
		`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`,
	)};
	z-index: ${zIndex.dialog};
`;

/**
 * Modals
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const e300 = css`
	box-shadow: ${token(
		'elevation.shadow.overlay',
		`0 8px 16px -4px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`,
	)};
	z-index: ${zIndex.modal};
`;

/**
 * (Side)Panels
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const e400 = css`
	box-shadow: ${token(
		'elevation.shadow.overlay',
		`0 12px 24px -6px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`,
	)};
	z-index: ${zIndex.panel};
`;

/**
 * Flag messages
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const e500 = css`
	box-shadow: ${token(
		'elevation.shadow.overlay',
		`0 20px 32px -8px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`,
	)};
	z-index: ${zIndex.flag};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const newElevationsFromDesignSystems = {
	// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
	e100: css`
		z-index: ${zIndex.card};
		box-shadow: ${token(
			'elevation.shadow.raised',
			`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`,
		)};
	`,
	// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
	e200: css`
		z-index: ${zIndex.dialog};
		box-shadow: ${token(
			'elevation.shadow.overlay',
			`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`,
		)};
	`,
};
